<template>
</template>

<script>
/**
 * Base component for all Vizzto UI library.
 * All components extend this one.
 * @module VzBase
 * @author Lanza
 */
export default {
  name: 'VzBase'
}
</script>

<style>

.vz-input label,
.vz-select label
{
  display: block;
  color: rgba(255,255,255,0.6);
  font-size: 0.93em;
  line-height: 1em;
  margin: 0 0 8px;
  padding: 0 0 0 32px;
}

</style>